import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

export default function SubCancelInfoModal({open, onClose}) {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="sub-cancel-dialog-title"
        aria-describedby="sub-cancel-dialog-description"
      >
        <DialogTitle id="sub-cancel-dialog-title">
          {t("views.subscriptions.cancelConfirmModalTitle")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="sub-cancel-dialog-description">
            {t("views.subscriptions.cancelConfirmModalExplanation")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="contained">OK</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}